import { Header, AMPHeaderAndSideBar } from 'mm-ui-components';
import { connect } from 'react-redux';
import {
    getCta,
    getEditionsLinks, getVideoLogo,
    getLinks as getPrimaryLinks,
    getLogos as getPrimaryLogo,
    getMenu,
} from '../../store/primaryHeader/primaryHeader.selectors';
import {
  getSecondaryHeader,
  getLinks as getSecondaryLinks,
  getLogos as getSecondaryLogos,
  getMoreLinksText,
} from '../../store/secondaryHeader/secondaryHeader.selectors';
import { AppState } from '../../store/initialStateRegistration';
import { getPropertyEndpoint, getPagePath } from '../../store/config/config.selectors';

export const mapStateToProps = (state:AppState) => {
  const primaryHeader = {
    primaryLinks: getPrimaryLinks(state),
    primaryLogos: getPrimaryLogo(state),
    editions: getEditionsLinks(state),
    cta: getCta(state),
    menu: getMenu(state),
    videoLogo: getVideoLogo(state),
    pagePath: getPagePath(state),
    editionEndpoint: getPropertyEndpoint(state),
  };
  const secondaryHeader = getSecondaryHeader(state) ? {
    secondaryLogos: getSecondaryLogos(state),
    secondaryLinks: getSecondaryLinks(state),
    moreLinksText: getMoreLinksText(state),
    pagePath: getPagePath(state),
  } : null;
  return {
    primaryHeader,
    secondaryHeader,
  };
};

export const HeaderConnected = connect(mapStateToProps)(Header);
export const AMPHeaderConnected = connect(mapStateToProps)(AMPHeaderAndSideBar);
